import { containerWidth } from "./layout";

export const breakpoints = {
  120: containerWidth.full,
  110: "1130px",
  100: "1060px",
  95: "1024px",
  90: "960px",
  85: "880px",
  82: "845px",
  80: "800px",
  75: "760px",
  70: "700px",
  65: "690px",
  60: "620px",
  50: "560px",
  40: "480px",
  35: "450px",
  30: "400px",
  20: "350px"
};

export default ``;
